import { Auth, Hub } from 'aws-amplify';
import { connect } from 'react-redux';
import { Component } from 'react';
import { PropTypes } from 'prop-types';

import { completeSignIn } from '../../actions/auth';

import { receiveErrorResponse } from '../../actions/api';

class AmplifyHub extends Component {
  constructor(props) {
    super(props);

    const { completeSignIn, receiveErrorResponse } = this.props;
    Hub.listen('auth', ({ payload: { event } }) => {
      switch (event) {
        case 'signIn':
          Auth.currentAuthenticatedUser().then(data => {
            completeSignIn(data);
          });
          break;
        case 'signIn_failure':
          receiveErrorResponse({
            response: {
              status: 401
            }
          });
          break;
        default:
          break;
      }
    });
  }

  render() {
    return this.props.children;
  }
}

AmplifyHub.propTypes = {
  completeSignIn: PropTypes.func.isRequired,
  receiveErrorResponse: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};

const mapDispatchToProps = {
  completeSignIn,
  receiveErrorResponse
};

export default connect(
  null,
  mapDispatchToProps
)(AmplifyHub);
